module.exports = __webpack_public_path__ + "img/coba.e58852d5.svg";